(function () {
  'use strict';

  var rootSelector = '[data-kk-hero-root]';
  var sliderSelector = '[data-kk-hero-slider]';
  var trustListSelector = '[data-kk-hero-trust-list]';
  var trustItemSelector = '[data-kk-hero-trust-item]';
  var trustRotationDelay = 3000;

  function hydrateSlide(slide) {
    if (!slide || slide.dataset.kkHeroHydrated === 'true') return;

    slide.querySelectorAll('[data-kk-hero-srcset]').forEach(function (source) {
      source.srcset = source.dataset.kkHeroSrcset;
      source.removeAttribute('data-kk-hero-srcset');
    });

    slide.querySelectorAll('[data-kk-hero-src]').forEach(function (image) {
      if (image.dataset.kkHeroSrcset) {
        image.srcset = image.dataset.kkHeroSrcset;
        image.removeAttribute('data-kk-hero-srcset');
      }
      image.src = image.dataset.kkHeroSrc;
      image.removeAttribute('data-kk-hero-src');
    });

    slide.dataset.kkHeroHydrated = 'true';
  }

  function initTrustRotation(root) {
    if (!root || root.dataset.kkHeroTrustReady === 'true') return;

    var list = root.querySelector(trustListSelector);
    if (!list) return;

    var items = Array.prototype.slice.call(list.querySelectorAll(trustItemSelector));
    if (!items.length) return;

    root.dataset.kkHeroTrustReady = 'true';

    var mobileQuery = window.matchMedia
      ? window.matchMedia('(max-width: 719px)')
      : { matches: window.innerWidth <= 719 };
    var reducedMotionQuery = window.matchMedia
      ? window.matchMedia('(prefers-reduced-motion: reduce)')
      : { matches: false };
    var currentIndex = Math.max(0, items.findIndex(function (item) {
      return item.classList.contains('is-active');
    }));
    var timer = 0;
    var interactionPaused = false;
    var sectionVisible = !('IntersectionObserver' in window);

    function clearTimer() {
      if (!timer) return;
      window.clearTimeout(timer);
      timer = 0;
    }

    function updateState(nextIndex) {
      var mobile = mobileQuery.matches;
      currentIndex = (nextIndex + items.length) % items.length;

      items.forEach(function (item, index) {
        var active = !mobile || index === currentIndex;
        item.classList.toggle('is-active', active);

        if (mobile) {
          item.setAttribute('aria-hidden', active ? 'false' : 'true');
          if (active) {
            item.removeAttribute('inert');
          } else {
            item.setAttribute('inert', '');
          }
        } else {
          item.removeAttribute('aria-hidden');
          item.removeAttribute('inert');
        }
      });
    }

    function scheduleRotation() {
      clearTimer();
      if (
        items.length < 2 ||
        !mobileQuery.matches ||
        reducedMotionQuery.matches ||
        interactionPaused ||
        !sectionVisible ||
        document.hidden
      ) {
        return;
      }

      timer = window.setTimeout(function () {
        if (
          !root.isConnected ||
          !sectionVisible ||
          reducedMotionQuery.matches ||
          document.hidden
        ) {
          scheduleRotation();
          return;
        }
        updateState(currentIndex + 1);
        scheduleRotation();
      }, trustRotationDelay);
    }

    function refresh() {
      updateState(currentIndex);
      scheduleRotation();
    }

    list.addEventListener('focusin', function () {
      interactionPaused = true;
      clearTimer();
    });

    list.addEventListener('focusout', function (event) {
      if (list.contains(event.relatedTarget)) return;
      interactionPaused = false;
      scheduleRotation();
    });

    document.addEventListener('visibilitychange', scheduleRotation);

    if ('IntersectionObserver' in window) {
      var visibilityObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.target !== root) return;
          sectionVisible = entry.isIntersecting && entry.intersectionRatio > 0;
          if (sectionVisible) {
            scheduleRotation();
          } else {
            clearTimer();
          }
        });
      }, { threshold: [0, 0.01] });

      visibilityObserver.observe(root);
    }

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', refresh);
      reducedMotionQuery.addEventListener('change', refresh);
    } else if (mobileQuery.addListener) {
      mobileQuery.addListener(refresh);
      reducedMotionQuery.addListener(refresh);
    }

    if (window.Shopify && window.Shopify.designMode) {
      root.addEventListener('shopify:block:select', function (event) {
        var selectedItem = event.target.closest(trustItemSelector);
        if (!selectedItem || !root.contains(selectedItem)) return;
        var selectedIndex = items.indexOf(selectedItem);
        if (selectedIndex < 0) return;
        currentIndex = selectedIndex;
        updateState(currentIndex);
        scheduleRotation();
      });
    }

    refresh();
  }

  function initHero(root) {
    if (!root) return;

    initTrustRotation(root);
    if (root.dataset.kkHeroReady === 'true') return;

    var slider = root.querySelector(sliderSelector);
    if (!slider) return;

    var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-kk-hero-slide]'));
    if (!slides.length) return;

    root.dataset.kkHeroReady = 'true';

    var previousButton = slider.querySelector('[data-kk-hero-previous]');
    var nextButton = slider.querySelector('[data-kk-hero-next]');
    var toggleButton = slider.querySelector('[data-kk-hero-toggle]');
    var status = slider.querySelector('[data-kk-hero-status]');
    var dots = Array.prototype.slice.call(slider.querySelectorAll('[data-kk-hero-dot]'));
    var currentIndex = Math.max(0, slides.findIndex(function (slide) {
      return slide.classList.contains('is-active');
    }));
    var autoplayEnabled = slider.dataset.autoplay === 'true';
    var pauseOnHover = slider.dataset.pauseOnHover === 'true';
    var autoplayDelay = Math.max(5, Number(slider.dataset.autoplaySeconds) || 7) * 1000;
    var nextSlidePreloadLeadTime = Math.min(2000, Math.max(1200, autoplayDelay * 0.3));
    var manuallyPaused = false;
    var interactionPaused = false;
    var timer = 0;
    var preloadTimer = 0;
    var pointerStartX = null;
    var suppressSlideLinkClickUntil = 0;
    var reducedMotionQuery = window.matchMedia
      ? window.matchMedia('(prefers-reduced-motion: reduce)')
      : { matches: false };
    var sectionVisible = !('IntersectionObserver' in window);

    function updateToggle() {
      if (!toggleButton) return;
      var paused = (
        manuallyPaused ||
        interactionPaused ||
        !autoplayEnabled ||
        reducedMotionQuery.matches ||
        !sectionVisible ||
        document.hidden
      );
      toggleButton.classList.toggle('is-paused', paused);
      toggleButton.setAttribute(
        'aria-label',
        paused ? toggleButton.dataset.playLabel : toggleButton.dataset.pauseLabel
      );
    }

    function clearTimer() {
      if (timer) {
        window.clearTimeout(timer);
        timer = 0;
      }
      if (preloadTimer) {
        window.clearTimeout(preloadTimer);
        preloadTimer = 0;
      }
    }

    function scheduleAutoplay() {
      clearTimer();
      root.setAttribute(
        'data-kk-motion-paused',
        (!sectionVisible || document.hidden || reducedMotionQuery.matches) ? 'true' : 'false'
      );
      if (
        slides.length < 2 ||
        !autoplayEnabled ||
        manuallyPaused ||
        interactionPaused ||
        reducedMotionQuery.matches ||
        !sectionVisible ||
        document.hidden
      ) {
        updateToggle();
        return;
      }

      var nextIndex = (currentIndex + 1) % slides.length;
      var preloadDelay = Math.max(0, autoplayDelay - nextSlidePreloadLeadTime);

      preloadTimer = window.setTimeout(function () {
        preloadTimer = 0;
        if (
          !root.isConnected ||
          !sectionVisible ||
          reducedMotionQuery.matches ||
          document.hidden
        ) {
          return;
        }
        hydrateSlide(slides[nextIndex]);
      }, preloadDelay);

      timer = window.setTimeout(function () {
        if (
          !root.isConnected ||
          !sectionVisible ||
          reducedMotionQuery.matches ||
          document.hidden
        ) {
          scheduleAutoplay();
          return;
        }
        selectSlide(currentIndex + 1, false);
      }, autoplayDelay);
      updateToggle();
    }

    function updateState(nextIndex) {
      slides.forEach(function (slide, index) {
        var active = index === nextIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (active) {
          slide.removeAttribute('inert');
        } else {
          slide.setAttribute('inert', '');
        }
      });

      dots.forEach(function (dot, index) {
        var active = index === nextIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });

      if (status) {
        status.textContent = slides[nextIndex].getAttribute('aria-label') || '';
      }
    }

    function selectSlide(index, userInitiated) {
      if (slides.length < 2) return;

      var nextIndex = (index + slides.length) % slides.length;
      if (nextIndex === currentIndex) {
        scheduleAutoplay();
        return;
      }

      hydrateSlide(slides[nextIndex]);
      currentIndex = nextIndex;
      updateState(currentIndex);

      if (userInitiated && autoplayEnabled) {
        clearTimer();
      }
      scheduleAutoplay();
    }

    hydrateSlide(slides[currentIndex]);

    if (previousButton) {
      previousButton.addEventListener('click', function () {
        selectSlide(currentIndex - 1, true);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        selectSlide(currentIndex + 1, true);
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        selectSlide(Number(dot.dataset.kkHeroDot) || 0, true);
      });
    });

    if (toggleButton) {
      toggleButton.addEventListener('click', function () {
        manuallyPaused = !manuallyPaused;
        scheduleAutoplay();
      });
    }

    root.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        selectSlide(currentIndex - 1, true);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        selectSlide(currentIndex + 1, true);
      }
    });

    root.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'mouse') return;
      pointerStartX = event.clientX;
    }, { passive: true });

    root.addEventListener('pointerup', function (event) {
      if (pointerStartX === null || event.pointerType === 'mouse') return;
      var distance = event.clientX - pointerStartX;
      pointerStartX = null;
      if (Math.abs(distance) < 45) return;
      suppressSlideLinkClickUntil = Date.now() + 500;
      selectSlide(currentIndex + (distance < 0 ? 1 : -1), true);
    }, { passive: true });

    root.addEventListener('click', function (event) {
      if (
        Date.now() > suppressSlideLinkClickUntil ||
        !event.target.closest('.kk-home-hero__slide-link')
      ) {
        return;
      }
      event.preventDefault();
      suppressSlideLinkClickUntil = 0;
    }, true);

    root.addEventListener('pointercancel', function () {
      pointerStartX = null;
    }, { passive: true });

    if (pauseOnHover) {
      root.addEventListener('mouseenter', function () {
        interactionPaused = true;
        clearTimer();
        updateToggle();
      });
      root.addEventListener('mouseleave', function () {
        interactionPaused = false;
        scheduleAutoplay();
      });
    }

    root.addEventListener('focusin', function () {
      interactionPaused = true;
      clearTimer();
      updateToggle();
    });

    root.addEventListener('focusout', function (event) {
      if (root.contains(event.relatedTarget)) return;
      interactionPaused = false;
      scheduleAutoplay();
    });

    document.addEventListener('visibilitychange', scheduleAutoplay);

    var motionChange = function () {
      scheduleAutoplay();
    };

    if (reducedMotionQuery.addEventListener) {
      reducedMotionQuery.addEventListener('change', motionChange);
    } else if (reducedMotionQuery.addListener) {
      reducedMotionQuery.addListener(motionChange);
    }

    if ('IntersectionObserver' in window) {
      var visibilityObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.target !== root) return;
          sectionVisible = entry.isIntersecting && entry.intersectionRatio > 0;
          scheduleAutoplay();
        });
      }, { threshold: [0, 0.01] });

      visibilityObserver.observe(root);
    }

    if (window.Shopify && window.Shopify.designMode) {
      root.addEventListener('shopify:block:select', function (event) {
        var selectedSlide = event.target.closest('[data-kk-hero-slide]');
        if (!selectedSlide || !root.contains(selectedSlide)) return;
        var selectedIndex = slides.indexOf(selectedSlide);
        if (selectedIndex > -1) {
          manuallyPaused = true;
          selectSlide(selectedIndex, true);
          updateToggle();
        }
      });
    }

    updateState(currentIndex);
    scheduleAutoplay();
  }

  function initAll(scope) {
    var context = scope || document;
    if (context.matches && context.matches(rootSelector)) {
      initHero(context);
    }
    context.querySelectorAll(rootSelector).forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    }, { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
